<template>
    <div :id="'comment-' + id"
         class="live-line-item">
        <div class="header-video-info">
            <img class="header-avater"
                 :src="avatar"
                 alt="直播员头像">
            <div class="header-video-txt">
                <div class="header-video-name">
                    <span>{{username}}</span><em class="tips">{{grade}}</em>
                </div>
                <div class="header-video-time">{{createTime}}</div>
            </div>
            <Like :name="'liked:comment:' + id"></Like>
        </div>
        <div class="live-content">
            <div class="live-txt"
                 v-html="context"></div>
            <!--<div class="video-location"
                 v-if="address"
                 style="padding: 0.1rem 0;">
                <div class="video-addr">{{address}}</div>
            </div>-->
        </div>
    </div>
</template>

<script>
import Video from "../video"
import Like from "./like"

export default {
    name: "Comment",
    components: {
        Video,
        Like
    },
    data () {
        return {
            width: "100%",
            height: window.screen.width * (9 / 16) + 'px'
        }
    },
    props: {
        id: Number,
        avatar: String,
        username: String,
        grade: String,
        createTime: String,
        context: String,
        address: String,
        images: Array,
        video: {
            url: String,
            poster: String,
        }
    },
    methods: {
        listenEnterFullScreen () {
            if (window.api && typeof window.api.enterFullScreen === 'function') {
                window.api.enterFullScreen()
            }
        },
        listenExitFullScreen () {
            this.$preview.on('destroy', () => {
                if (window.api && typeof window.api.exitFullScreen === 'function') {
                    window.api.exitFullScreen()
                }
            })
        }
    },
    mounted () {
        this.listenExitFullScreen()
    }
}
</script>

<style scoped>
.video-wrap div {
    width: 100%;
    height: auto;
}
</style>
